// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home', to: '/' },
    { label: 'Sports', to: '/sports' },
    { label: 'Live Betting', to: '/live' },
    { label: 'Casino', to: '/casino' },
    { label: 'Promotions', to: '/promotions' },
    { label: 'Esports', to: '/esports' }
  ];

  const companyLinks = [
    { label: 'About Us', to: '/about' },
    { label: 'Contact Us', to: '/contact' },
    { label: 'Terms & Conditions', to: '/terms' },
    { label: 'Privacy Policy', to: '/privacy' },
    { label: 'Responsible Gambling', to: '/responsible-gambling' },
    { label: 'FAQ', to: '/faq' }
  ];

  const paymentMethods = [
    { name: 'PayPal', icon: '🏦' },
    { name: 'Cryptocurrency', icon: '₿' }
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-gray-400 border-t border-gray-800">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-10 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
               {/* Logo */}
                <Link to="/" className="flex items-center hover:opacity-90 transition-opacity">
                <img 
                    src={Logo} 
                    alt="DiceAce12 Logo" 
                    className="h-10 w-auto" 
                />
                </Link>
              <div>
                <h3 className="text-xl font-bold text-white">DiceAce21</h3>
                <p className="text-sm text-gray-500">Premium Betting Experience</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6">
              The ultimate destination for sports betting, live casino, and esports. 
              Trusted by millions of players worldwide.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-lg">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-gray-400 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 rounded-full bg-blue-600 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-lg">Company</h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-gray-400 hover:text-blue-400 transition-colors duration-300 flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 rounded-full bg-blue-600 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            
            {/* Age Restriction */}
            <div className="mt-8 p-4 bg-gray-900/50 rounded-lg border border-gray-800">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-red-600 flex items-center justify-center text-white font-bold">
                  18+
                </div>
                <div>
                  <div className="text-white text-sm font-medium">Age Restricted</div>
                  <div className="text-gray-500 text-xs">Must be 18+ to play</div>
                </div>
              </div>
            </div>
          </div>

          {/* Payment & Licenses */}
          <div>
            <h4 className="text-white font-semibold mb-6 text-lg">Payment Methods</h4>
            <div className="grid grid-cols-3 gap-3 mb-8">
              {paymentMethods.map((method) => (
                <div
                  key={method.name}
                  className="bg-gray-900/50 rounded-lg p-3 text-center hover:bg-gray-800 transition-colors duration-300 border border-gray-800"
                  title={method.name}
                >
                  <div className="text-2xl mb-1">{method.icon}</div>
                  <div className="text-xs text-gray-500 truncate">{method.name}</div>
                </div>
              ))}
            </div>
          
          </div>
        </div>

        {/* Trust Badges */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-3xl mb-2">🔒</div>
              <div className="text-white font-medium">Secure</div>
              <div className="text-gray-500 text-sm">256-bit SSL Encryption</div>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-2">⚡</div>
              <div className="text-white font-medium">Fast Payouts</div>
              <div className="text-gray-500 text-sm">Within 24 Hours</div>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-2">🎮</div>
              <div className="text-white font-medium">Live Support</div>
              <div className="text-gray-500 text-sm">24/7 Customer Service</div>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-2">⭐</div>
              <div className="text-white font-medium">Trusted</div>
              <div className="text-gray-500 text-sm">4.8/5 Rating</div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Bottom Bar */}
      <div className="bg-black/50 border-t border-gray-900">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Copyright */}
            <div className="text-gray-500 text-sm text-center md:text-left">
              © {currentYear} DiceAce12. All rights reserved.
            </div>

            {/* Language & Currency */}
            <div className="flex items-center gap-4">
              <select className="bg-gray-900 text-white text-sm px-3 py-2 rounded-lg border border-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-600">
                <option>English</option>
                <option>Español</option>
                <option>Français</option>
                <option>Deutsch</option>
              </select>
              <select className="bg-gray-900 text-white text-sm px-3 py-2 rounded-lg border border-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-600">
                <option>USD ($)</option>
                <option>EUR (€)</option>
                <option>GBP (£)</option>
                <option>JPY (¥)</option>
              </select>
            </div>
          </div>

          {/* Legal Disclaimer */}
          <div className="mt-4 text-center">
            <p className="text-xs text-gray-600 max-w-3xl mx-auto">
              DiceAce12 is licensed and regulated. Gambling involves risk. Please play responsibly. 
              Players must be 18+. Underage gambling is an offense. Terms and conditions apply.
            </p>
          </div>
        </div>
      </div>

      {/* Live Support Button */}
      
    </footer>
  );
};

export default Footer;